import React, { Component } from 'react';

import Button from 'base/components/Button';
import mask from 'assets/img/maska.png';

export default class StartPage extends Component {
  render() {
    return (
      <div className="startpage-body">
        <div className="startpage-container">
            {/* <div className="startpage-logo" /> */}
            <h1 className="startpage-header">8 Twarzy IZETU</h1>
            <img className="startpage-img" src={mask} alt="" />
            {/* <p className="startpage-subheader">Bal Maskowy</p> */}
            <span className="startpage-buttons-wrapper">
              <Button url="/entry-form">Zapisz się!</Button>
              {/* <Button url="/tables">Stoliki</Button> */}
            </span>
        </div>
        <p className="promo-text">Aplikację do obsługi wydarzeń rozwija <a href="http://nativeflow.napwr.pl">KN Native Flow</a></p>
      </div>
    )
  }
};



// WEBPACK FOOTER //
// ./src/modules/User/views/StartPage.js